export default __webpack_public_path__ + "static/media/profile.5af75cd0.png";